import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaValue from './VaValue.vue'

export const VaValue = withConfigTransport(_VaValue)
